import { ReferenceTableItemAddedEvent, } from '../event/reference-table-item-added.event';
import { ReferenceTableItemEntity } from '../reference-table-item.entity';
const referenceTableItemAddedProjections = {
    [ReferenceTableItemAddedEvent.name]: (event, state) => {
        const payload = event.getPayload();
        const newItems = new Map(state.items);
        const item = new ReferenceTableItemEntity({
            id: payload.itemId,
            attributes: payload.attributes,
            tp2LookupTableItemId: payload.tp2LookupTableItemId,
        });
        newItems.set(payload.itemId, item);
        return {
            ...state,
            items: newItems,
        };
    },
};
export default referenceTableItemAddedProjections;
//# sourceMappingURL=reference-table-item-added.projection.js.map